import axios from './financeiroApi';

// TODO: utilizar financeiro-api quando endpoint estiver disponível

const getPath = () => `/api/v1/backend/conta`;

const contaApi = {
  get: (search) => {
    const url = `${getPath()}?page=${search.page}&size=${search.size}${
      search.q ? `&q=${search.q}` : ''
    }&sort=principal,DESC&sort=${search.sort || 'descricao,ASC'}`;

    // return contasMock.get(search);
    return axios.get(url);
  },
  getOne: (contaId) => {
    const url = `${getPath()}/${contaId}`;
    // return contasMock.getOne(contaId);
    return axios.get(url);
  },
  post: (conta) => {
    const url = `${getPath()}`;
    return axios.post(url, conta);
  },
  put: (contaId, conta) => {
    const url = `${getPath()}/${contaId}`;
    return axios.put(url, conta);
  },
  delete: (filtro) => {
    const url = `${getPath()}`;
    return axios.delete(url, { data: filtro });
  },
  getContasCorrente: () => {
    const url = `${getPath()}/bancaria-corrente`;
    return axios.get(url);
  },
  getHistorico: (contaId) => {
    const url = `${getPath()}/${contaId}/historico`;
    return axios.get(url);
  },
  pesquisar: (params) => {
    const url = `${getPath()}/pesquisar`;
    return axios.get(url, { params });
  },
  getContaPrincipalPartnerBank: async (params) => {
    const url = `${getPath()}/principal-partner-bank`;
    return axios.get(url, { params });
  },
};

export { contaApi };
